import React from 'react';
import { motion } from 'framer-motion';

const Services = () => {
  const services = [
    {
      title: 'Clases Grupales',
      description: 'Aprende Inglés en un ambiente compartido donde tu docente te dará las herramientas en lectura, conversación, gramática y escritura que necesites.',
      features: ['Matrícula GRATIS', 'Material Exclusivo de OEC', 'Clases 100% en vivo', 'Acceso a plataformas de estudio GRATIS', 'Asesoría personalizada por WhatsApp', 'Resultados 100% garantizados'],
      price: '$35/Al mes',
      color: 'from-pink-primary to-red-primary'
    },
    {
      title: 'Clases de Conversación',
      description: 'Practica la pronunciación correcta, gramática y técnicas de fluidez para cumplir tus objetivos con un programa enfocado en tus metas (negocios, estudios, viajes, etc.) en un ambiente VIP.',
      features: ['Matrícula GRATIS', 'Material Exclusivo de OEC', 'Clases 100% en vivo', 'Asesoría personalizada por WhatsApp', 'Programa especializado a tus metas (laboral, estudio, cultura, viajes, etc).', 'Oportunidades de desenvolverte con invitados especiales nativos'],
      price: '$45/Al mes',
      color: 'from-red-primary to-yellow-primary'
    },
    {
      title: 'TOEIC Prep Course',
      description: 'Si necesitas pasar el TOEIC con una puntuación alta, OEC te ofrece prácticas, simulacros de examen, tips y estrategias con resultados 100% reales.',
      features: ['Matrícula GRATIS', 'Material Exclusivo de OEC', 'Clases 100% en vivo', 'Acceso a plataformas de estudio GRATIS', 'Asesoría personalizada por WhatsApp', 'Resultados 100% garantizados', 'Oportunidades de desenvolverte con invitados especiales nativos'],
      price: '$80/Al mes',
      color: 'from-pink-primary/80 to-red-primary/80'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-league-spartan font-bold text-black mb-6">
            Nuestros <span className="text-red-primary">Planes</span>
          </h2>
          <div className="w-24 h-1 bg-yellow-primary mx-auto mb-8"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Escoge el plan que mejor se ajuste a tus metas y bolsillo
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
              className="relative group"
            >
              <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100">
                <div className={`h-2 bg-gradient-to-r ${service.color}`}></div>
                
                <div className="p-8">
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="text-2xl font-semibold text-black group-hover:text-red-primary transition-colors duration-300">
                      {service.title}
                    </h3>
                    <span className="text-lg font-bold text-red-primary bg-red-primary/10 px-3 py-1 rounded-full text-sm">
                      {service.price}
                    </span>
                  </div>
                  
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {service.description}
                  </p>

                  <div className="space-y-3">
                    <h4 className="font-semibold text-black mb-3">Incluye:</h4>
                    {service.features.map((feature, featureIndex) => (
                      <motion.div
                        key={featureIndex}
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 + featureIndex * 0.1 }}
                        viewport={{ once: true }}
                        className="flex items-center"
                      >
                        <div className="w-2 h-2 bg-yellow-primary rounded-full mr-3"></div>
                        <span className="text-gray-700">{feature}</span>
                      </motion.div>
                    ))}
                  </div>

                  <motion.button
                    className="w-full mt-8 bg-gradient-to-r from-pink-primary to-red-primary text-white py-3 rounded-full font-semibold hover:shadow-lg transition-all duration-300"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => window.open('https://wa.me/50364376585', '_blank')}
                  >
                    Comenzar
                  </motion.button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <div className="bg-gradient-to-r from-pink-primary/10 to-yellow-primary/10 p-8 rounded-2xl max-w-4xl mx-auto">
            <h3 className="text-2xl font-semibold text-black mb-4">
              ¿No estás seguro de qué curso es adecuado para ti?
            </h3>
            <p className="text-gray-700 mb-6">
              Contáctanos para una consulta gratuita y deja que nuestros expertos te ayuden a elegir el camino de aprendizaje perfecto.
            </p>
            <motion.button
              className="bg-red-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-red-700 transition-colors duration-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => window.open('https://wa.me/50364376585', '_blank')}
            >
              Consulta gratuita
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;